import app from '../common_app.es6';

app.filter('urlSafe', ['$sce', function ($sce) {
  return function(url) { return $sce.trustAsResourceUrl(url); };
}]);